import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=d3df0a90&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3df0a90",
  null
  
)

export default component.exports